import { flowRight, find } from 'lodash';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';
import { DoctorCardView } from './DoctorCardView';
import { saveProfessional } from './DoctorCardActions';
import {
    SCHEDULING_ROOT_KEY,
    DOCTOR_CARD_ROOT_KEY,
    TRACKING_CONSTANTS,
} from '../../constants';
import { withProvider } from '../../../gql';
import patientSelector from '../../selectors/PatientSelector';

const getSelectedPatientName = (state, patientId) => {
    const patient = patientSelector(state);
    if (patient && patientId) {
        const patientIdAsInt = parseInt(patientId, 10);
        if (patient.patientFirstName && patient.patientId === patientIdAsInt) {
            return `${patient.patientFirstName} ${patient.patientLastName}`;
        } else {
            const subPatient = find(
                patient.subpatients,
                x => x.patientId === patientIdAsInt
            );
            if (subPatient) {
                return `${subPatient.firstName} ${subPatient.lastName}`;
            }
        }
    }
    return undefined;
};

export const mapStateToProps = state => {
    const { bookingState } = state[SCHEDULING_ROOT_KEY];
    const { hasProfessional } = state[DOCTOR_CARD_ROOT_KEY];
    const patientId = bookingState ? bookingState.patient_id : undefined;
    const patientName = getSelectedPatientName(state, patientId);
    const { metrics = {} } = state.ssr || {};

    return {
        hasProfessional,
        patientName,
        pageName: metrics.page || '',
    };
};

export const mapDispatchToProps = {
    saveProfessional,
};

export const DoctorCardContainer = flowRight(
    withCustomMetrics({ component: TRACKING_CONSTANTS.ProviderCard }),
    connect(mapStateToProps, mapDispatchToProps),
    withProvider
)(DoctorCardView);
